// ProgramEvent is equivalent of ApplicationType

import { InternalApplicationStatuses, EventStatuses } from "../common/constants/statuses";

export const getAvailableProgramEvents = (events, applications) => {
  return events?.filter(event => event.isActive && event.eventStatus === EventStatuses.Active &&
    !applications.some(item => item.applicationType.toLowerCase() === event.code.toLowerCase() &&
                               item.internalStatus !== InternalApplicationStatuses.Withdrawn &&
                               item.internalStatus !== InternalApplicationStatuses.Rejected)
  );
}